import { gql } from '@apollo/client';

export const CREATE_PORTFOLIO = gql`
  mutation CreatePortfolio($name: String!) {
    createPortfolio(name: $name) {
      success
      error
      portfolio {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_PORTFOLIO = gql`
  mutation UpdatePortfolio($id: ID!, $name: String!) {
    updatePortfolio(id: $id, name: $name) {
      success
      error
      portfolio {
        id
        name
        currency
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_PORTFOLIO_CURRENCY = gql`
  mutation UpdatePortfolioCurrency($id: ID!, $currency: String!) {
    updatePortfolioCurrency(id: $id, currency: $currency) {
      success
      error
      portfolio {
        id
        name
        currency
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_PORTFOLIO = gql`
  mutation DeletePortfolio($id: ID!) {
    deletePortfolio(id: $id)
  }
`; 